import { render, staticRenderFns } from "./get-all-user-unfunded-products.vue?vue&type=template&id=0ce988f6&"
import script from "./get-all-user-unfunded-products.vue?vue&type=script&lang=js&"
export * from "./get-all-user-unfunded-products.vue?vue&type=script&lang=js&"
import style0 from "./get-all-user-unfunded-products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VCard,VCardTitle,VDataTable,VFlex,VSpacer,VTextField})
